<template>
  <div v-loading="loading">
    <el-row>
      <el-col :span="24">
        <el-row style="text-align:left">
          <br>
          <el-col :span="18">
            <el-form :inline="true"
                     class="demo-form-inline">
              <el-form-item label="公司选择">
                <el-select v-model="companyName"
                           filterable
                           remote
                           :remote-method="searchStock"
                           default-first-option
                           placeholder="搜索公司名称">
                  <el-option v-for="item in options"
                             :key="item.name"
                             :label="item.name"
                             :value="item.name">
                  </el-option>
                </el-select>

              </el-form-item>

              <el-form-item>
                <el-button type="primary"
                           @click="openTypeDialog(companyName)">分析一下</el-button>

                <el-button @click="searchConcept(companyName)"
                           :disabled="!companyName">查询相关概念</el-button>

                <template v-if="relConcept && relConcept.length===0">
                  &nbsp;未搜索到相关概念
                </template>
                <template v-else>
                  <template v-for="item in relConcept">
                    &nbsp; <el-link :underline="true"
                             :key="item.id"
                             @click="openConceptTypeDialog(item.bkCode)">{{item.bkName}}</el-link>
                  </template>
                </template>

              </el-form-item>
            </el-form>

          </el-col>
        </el-row>
        <el-row>
          <br>

          <el-col :span="24">
            <h3 style="text-align:left">
              热门概念相关公司
            </h3>
            <br>
            <el-table :data="conceptUpDlowList && conceptUpDlowList.primary">
              <el-table-column label="概念"
                               width="200">
                <template slot-scope="scope">
                  {{scope.row.bk_name}}
                </template>
              </el-table-column>

              <el-table-column label="价格/涨幅"
                               width="200">
                <template slot-scope="scope">

                  <template v-if="parseFloat(scope.row.chg) >= 0">
                    <span style="color:red"> {{scope.row.chg}}↑</span>
                  </template>
                  <template v-else>
                    <span style="color:green"> {{scope.row.chg}}↓</span>
                  </template>
                </template>
              </el-table-column>

              <el-table-column label="相关公司数量"
                               prop="company_count"
                               width="200">
              </el-table-column>

              <el-table-column label="相关公司">
                <template slot-scope="scope">
                  <template v-for="(item,index) in scope.row.company_names">
                    <el-col :key="index"
                            :span="12">
                      <el-link @click="openTypeDialog(item)"
                               type="text"
                               size="small">{{item}}&nbsp;</el-link>
                    </el-col>
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </el-col>

        </el-row>
      </el-col>
    </el-row>
    <!--类型选择框-->
    <el-dialog title="个股分析"
               width="500px"
               :visible.sync="typeDialogVisible">
      <el-form>
        <el-form-item label="报告类型">
          <template>
            <!-- <el-radio v-model="reportType"
                      label="FULL">个股分析（增强版）</el-radio> -->
            <el-radio v-model="reportType"
                      label="SIMPLE">个股分析报告</el-radio>

            <el-radio v-model="reportType"
                      label="TINY">个股分析简报</el-radio>
          </template>
        </el-form-item>

        <el-form-item label="文件类型">
          <template>

            <el-radio v-model="fileType"
                      label="PDF">PDF</el-radio>
            <el-radio v-model="fileType"
                      label="DOC">word</el-radio>
          </template>
        </el-form-item>
        <GenDialog />
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="typeDialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="checkStock">生 成</el-button>
      </div>
    </el-dialog>

    <el-dialog width="500"
               top="0"
               :close-on-click-modal=false
               :visible.sync="pdfDialogVisible">
      <iframe :src="pdfUrl+'#toolbar=0'"
              title=""
              style="width: 100%;height: calc(100vh - 120px);border: 0;" />
      <div style="text-align:center">
        <el-button @click="toDownPdf()"
                   size="small">下载</el-button>
      </div>
    </el-dialog>

    <!--类型选择框-->
    <el-dialog title="概念分析"
               width="500px"
               :visible.sync="conceptDialogVisible">
      <el-form>

        <el-form-item label="文件类型">
          <template>
            <el-radio v-model="conceptFileType"
                      label="PDF">PDF</el-radio>
            <el-radio v-model="conceptFileType"
                      label="DOC">word</el-radio>
          </template>
        </el-form-item>
        <GenDialog />
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="conceptDialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="inputGenConcept">生 成</el-button>
      </div>
    </el-dialog>

    <!--二级市场分析-->
    <el-dialog title="二级市场分析"
               width="500px"
               :visible.sync="unListedDialogVisible">
      <el-form>

        <el-form-item label="文件类型">
          <template>
            <el-radio v-model="unlistedFileType"
                      label="PDF"
                      disabled>PDF</el-radio>
            <el-radio v-model="unlistedFileType"
                      label="DOC">word</el-radio>
          </template>
        </el-form-item>
        <GenDialog />
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="unListedDialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="genUnlistedReport">生 成</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import axios from 'axios'
import GenDialog from './GenDialog.vue'
export default {
  name: 'ele',
  data: function () {
    return {
      companyName: '',
      stockCode: '',
      reportType: 'SIMPLE',
      fileType: 'PDF',
      options: [],
      candidateOptions: [],
      pdfUrl: '',
      loading: false,
      hotStocks: [],
      pdfDialogVisible: false,
      tabsName: 'finance',
      openDate: '',
      openHtml: '',
      closeDate: '',
      closeHtml: '',
      curSourceId: '',
      typeDialogVisible: false,

      bkCode: {},
      conceptOptions: [],
      candidateConcept: [],
      conceptUpDlowList: [],

      conceptFileType: 'PDF',
      searchLogs: [],

      unlistedFileType: 'DOC',
      conceptDialogVisible: false,
      unListedDialogVisible: false,
      conceptSearchLogs: [],

      curReport: {},
      relConcept: null,
      curCompanyName: ''

    }
  },
  filters: {
    // dateFilter: function (v) {
    //   return moment(new Date(parseInt(v))).format('YYYY-MM-DD')
    // }
  },
  components: {
    GenDialog
  },
  computed: {

  },
  watch: {

  },

  methods: {
    inputGenConcept () {
      let _this = this
      _this.conceptDialogVisible = false
      this.loading = true
      axios.get('/api/web/concept/genReport/' + _this.conceptFileType + '/CONCEPT/' + this.bkCode).then(resp => {
        _this.loading = false
        _this.pdfUrl = ''
        _this.sourceId = resp.data.sourceId
        if (resp.data.hasPay === 'FALSE') {
          _this.curReport = resp.data
          _this.payDialogVisible = true
        } else {
          _this.payDialogVisible = false
          _this.$store.commit('toFreshUserPrice')
          if (resp.data.fileType === 'PDF') {
            _this.pdfUrl = '/api/web/stock/readPdf/' + this.sourceId
            _this.pdfDialogVisible = true
          } else {
            _this.toDownPdf()
          }
        }
      }).catch(e => {
        _this.loading = false
        if (e.code === 401) {
          _this.$alert(e.msg, '您的使用次数已超过限制，需要更多权限，请联系客服。')
        }
      })
    },

    genUnlistedReport () {
      let _this = this
      _this.unListedDialogVisible = false
      this.loading = true
      axios.get('/api/web/stock/genReport/' + _this.unlistedFileType + '/UNLISTED/' + this.curCompanyName).then(resp => {
        _this.loading = false
        _this.pdfUrl = ''
        _this.sourceId = resp.data.sourceId
        if (resp.data.hasPay === 'FALSE') {
          _this.curReport = resp.data
          _this.payDialogVisible = true
        } else {
          _this.payDialogVisible = false
          _this.$store.commit('toFreshUserPrice')
          if (resp.data.fileType === 'PDF') {
            _this.pdfUrl = '/api/web/stock/readPdf/' + this.sourceId
            _this.pdfDialogVisible = true
          } else {
            _this.toDownPdf()
          }
        }
      }).catch(e => {
        _this.loading = false
        if (e.code === 401) {
          _this.$alert(e.msg, '您的使用次数已超过限制，需要更多权限，请联系客服。')
        }
      })
    },
    openConceptTypeDialog (code) {
      if (!code) {
        this.$message.error('请选择概念')
        return
      }
      this.bkCode = code
      this.conceptDialogVisible = true
    },
    openTypeDialog (code) {
      if (!code) {
        this.$message.error('请输入公司名称')
        return
      }
      this.curCompanyName = code
      this.unListedDialogVisible = true
    },
    searchConcept (name) {
      let _this = this
      axios.get('/api/web/stock/searchConcept?name=' + name).then(resp => {
        _this.relConcept = resp.data
      })
    },

    checkStock () {
      let _this = this
      this.typeDialogVisible = false
      axios.get('/api/web/stock/checkStock/' + this.reportType + '/' + this.stockCode).then(resp => {
        var checkRes = resp.data
        var msg = ''
        for (var i = 0; i < checkRes.length; i++) {
          var temp = checkRes[i]
          switch (temp.list_status) {
            case 'L':
              console.log('正常')
              break
            case 'D':
              msg = msg + '股票【' + temp.short_name + '】已退市'
              console.log('退市')
              break
            case 'WD':
              msg = msg + '股票【' + temp.short_name + '】已退市整理'
              console.log('退市整理')
              break
            case 'ST':
              msg = msg + '股票【' + temp.short_name + '】已被证监会警告处理'
              console.log('证监会警告处理')
              break
            case 'ST* PT':
              msg = msg + '股票【' + temp.short_name + '】已被证监会警告处理'
              console.log('证监会警告处理')
              break
            case 'N':
              msg = msg + '股票【' + temp.short_name + '】为新股'
              console.log('新股')
              break
            case 'SN':
              msg = msg + '股票【' + temp.short_name + '】为次新股'
              console.log('次新股')
              break
            case 'PT':
              msg = msg + '股票【' + temp.short_name + '】等待退市'
              console.log('等待退市')
              break
            case 'P':
              msg = msg + '股票【' + temp.short_name + '】已暂停上市'
              console.log('暂停上市')
              break
          }
        }
        if (msg) { // 有不正常的股票
          msg = msg + ',报告数据可能缺失，是否继续生成？'
          this.$confirm(msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            _this.genPdf()
          })
        } else {
          _this.genPdf()
        }
      })
    },
    genPdf () {
      let _this = this
      this.loading = true
      axios.get('/api/web/stock/genReport/' + this.fileType + '/' + this.reportType + '/' + this.stockCode).then(resp => {
        _this.loading = false
        _this.pdfUrl = ''
        _this.sourceId = resp.data.sourceId

        if (resp.data.hasPay === 'FALSE') {
          _this.curReport = resp.data
          _this.payDialogVisible = true
        } else {
          _this.payDialogVisible = false
          _this.$store.commit('toFreshUserPrice')
          if (resp.data.fileType === 'PDF') {
            _this.pdfDialogVisible = true
            _this.pdfUrl = '/api/web/stock/readPdf/' + this.sourceId
          } else {
            _this.toDownPdf()
          }
        }
      }).catch(e => {
        _this.loading = false
        if (e.code === 401) {
          _this.$alert(e.msg, '您的使用次数已超过限制!')
        }
      })
    },

    searchStock (query) {
      query = query.trim()
      if (query) {
        let _this = this
        setTimeout(() => {
          axios.get('/api/web/stock/searchCompany?k=' + query).then(resp => {
            _this.options = resp.data.map((v) => { return { name: v.companyName } })
          })
        }, 200)
      } else {
        this.options = this.searchLogs
      }
    },

    toDownPdf () {
      window.open('/api/web/stock/downLoadReport/' + this.sourceId)
    }

  },

  mounted () {
    let _this = this
    try {
      this.conceptUpDlowList = localStorage.getItem('conceptUpDlowList')
    } catch (e) { }
    axios.get('/api/web/concept/upDowList').then(resp => {
      _this.conceptUpDlowList = resp.data
      localStorage.setItem('conceptUpDlowList', JSON.stringify(_this.conceptUpDlowList))
    })
  }
}
</script>
<style lang="less" scoped>
.openCloseIframe {
  border: 0px;
  width: 603px;
  height: calc(100vh - 203px);
}
.container-fluid {
  background: url("/static/img/courses-header.jpg");
  height: 400px;
}
.mydropzone {
  background: #0000;
  border: dashed 2px #fff6;
  border-radius: 10px;
  top: 50%;
  position: relative;
}
.mydropzone:focus {
  background: #0000 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/index/data.vue